import { Component, ViewChild, ElementRef } from '@angular/core';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '@app/_models';
import { UserService, AuthenticationService } from '@app/_services';
import { ShippingService } from '@app/_services';
import { FormBuilder } from '@angular/forms';
import { log } from 'util';
import { IMyOptions } from 'ng-uikit-pro-standard';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';


@Component({
  templateUrl: 'inventory.component.html',
  styleUrls: ['./inventory.component.scss']
})
export class InventoryComponent {
  @ViewChild('TABLE', { static: false }) TABLE: ElementRef;

  title = 'Excel';
  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.TABLE.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'inventory.xlsx');
  }

  exportPDF() {
    let DATA1 = this.TABLE.nativeElement;
    let doc = new jsPDF("p", "mm", "a4");
    var thetime = new Date();
    var datetime = `Date printed: ${thetime}`;
    html2canvas(DATA1).then(canvas => {
      var image1 = canvas.toDataURL('image/png', 0.1);
      var imgProps = doc.getImageProperties(image1);
      var width = doc.internal.pageSize.getWidth();
      var height = (imgProps.height * width) / imgProps.width;
      doc.setFontSize(8);
      doc.text(datetime, 5, doc.internal.pageSize.height - 3);
      doc.addImage(image1, 'png', 5, 10, width - 10, height);
      doc.save('inventory.pdf');
    });
  }

  public myDatePickerOptions: IMyOptions = {
    firstDayOfWeek: 'su' // 'mo' - Monday, 'tu' - Tuesday, 'we' - Wednesday, 'th' - Thursday, 'fr' - Friday, 'sa' - Saturday, 'su' - Sunday
  };

  isLoading = false;
  user: User;
  mainForm;
  total: number;
  inventoryInSEC;
  inventoryInCAS;
  boxInventory;

  constructor(
    private userService: UserService, private fb: FormBuilder,
    private router: Router,
    private shippingService: ShippingService,
    private authenticationService: AuthenticationService
  ) {
    this.user = this.authenticationService.userValue;
  }

  ngOnInit() {
    //this.isLoading = true;
    this.mainForm = this.fb.group({
      location:'All',
      customer: this.user.customer,
    });
    this.getBoxInventory();
    this.getInventory();
    
  }

  getInventory() {
    this.isLoading = true;
    this.shippingService.getInventoryBySku(this.mainForm.value).subscribe(data => {
      this.inventoryInSEC = data['inventoryInSEC'];
      this.inventoryInCAS = data['inventoryInCAS'];
      console.log(data);
      this.isLoading = false;
    });
  }

  getBoxInventory() {
    this.shippingService.getBoxInventory(this.mainForm.value).subscribe(data => {
      this.boxInventory = data as any[];
      console.log(this.boxInventory);
    });
  }

}
